import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';
import store from '../store';
import {i18n} from "@/app";

Vue.use(Router);

const appRouter = new Router({
	base: process.env.BASE_URL,
	routes: routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else {
			return { x: 0, y: 0 };
		}
	}
});

appRouter.beforeEach(async (to, from, next) => {
	const redirectRoutes = ["Login"];
	const nextProps = {};
	await store.dispatch('saveLoading', true);
	await store.dispatch('throwFatalError', false);
	await store.dispatch('checkAuthUserToken');
	const isAuth = to?.meta?.requiresAuth;
	const hasAuth = store?.state?.auth?.authUserToken;
	if (!isAuth) {
		if (hasAuth) {
			nextProps.name = 'Dashboard';
		}
	} else {
		if (!hasAuth) {
			nextProps.name = 'Login';
			nextProps.query = !redirectRoutes.includes(to.name) ? {redirect: to.fullPath} : {};
		}
	}
	await store.dispatch('saveTitle', i18n.t('titles.' + (nextProps?.name ?? to.name)));
	await store.dispatch('saveLoading', false);
	try {
		next(nextProps);
	} catch (error) {
		console.error("There was a problem navigating")
	}
});

export default appRouter;
